// extracted by mini-css-extract-plugin
export default {"800":"(min-width: 800px)","root":"it1v_zbqxOO9lyM7kbli","wrap":"eFzYLYCch7SkIdORJGbs","body":"px2rpne2iDLUrjIkqLS5","btn":"Ct31PgBjN2BpGy_Rpnf5"};